import React, { useEffect,useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { ChevronDown, ChevronUp, CheckCircle } from "lucide-react";

const reasons = [
  {
    title: "Leading eyewear shop in the region",
    description:
      "Trusted by thousands, we’re recognized for our supreme variety, quality, professional service and unbeatable product range.",
  },
  {
    title: "The biggest variety, all in one place",
    description:
      "With the most extensive selection of eyewear and solutions, you get everything under one roof. We assure you that we have everything for everyone who steps through our doors.",
  },
  {
    title: "Only Original, Certified Products",
    description:
      "We partner with globally recognized brands and guarantee 100% authenticity on every product.",
  },
  {
    title: "Warranty on Every Purchase",
    description:
      "When we say quality, rest assured. Shop with confidence with us as all our products come with a warranty that ensures quality and satisfaction.",
  },
  {
    title: "Exceptional After-Sales Service",
    description:
      "With every problem, our team is here to support you. Whether it is adjustments, support, or product guidance, our support team has solutions for all your queries.",
  },
  {
    title: "Complete Eye Care Solutions",
    description:
      "Beyond glasses and lenses, we offer a range of eye care essentials to support your daily routine.",
  },
  {
    title: "Expert Opticians & Friendly Staff",
    description:
      "Our team of certified professionals ensures you get the right fit, style, and advice—every time.",
  },
  {
    title: "Easy Access & Parking",
    description:
      "We are located at a convenient place with ample parking area, thus making your visit smooth & hassle-free.",
  },
];

const WhyPage = () => {
  const [openIndex, setOpenIndex] = useState(0); // First item open by default on mobile

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
    AOS.init({
      duration: 1000,  // Animation duration in ms
      once: true,      // Only animate once per element
    });
  }, []);

  return (
    <section className="bg-white px-4 py-6 md:px-12 md:py-10">
      <div data-aos="fade-right">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-manrope font-bold text-center text-[#3471B8] mb-8">
          Why Choose <br className="sm:hidden" />
          Eye care Optical?
        </h2>
      </div>

      {/* Desktop View */}
      <div className="hidden md:grid grid-cols-1 md:grid-cols-2 gap-6">
        {reasons.map((reason, index) => (

        <div data-aos="fade-up" data-aos-delay="300"
          key={index}
          className="bg-gradient-to-br from-[#E8F4F6] to-[#BEE2E9] p-6 rounded-xl flex items-center gap-4 shadow"
        >
          <div className="flex-shrink-0 flex items-center justify-center h-6">
            <CheckCircle className="text-[#3471B8] w-6 h-6" />
          </div>
          <div>
            <h3 className="text-[#343434] font-semibold font-manrope text-[20px] mb-1">
              {reason.title}
            </h3>
            <p className="text-[#343434] font-manrope text-[16px] leading-relaxed">
              {reason.description}
            </p>
          </div>
        </div>
        

        ))}
      </div>

      {/* Mobile Accordion View */}
      <div  data-aos="fade-up" data-aos-delay="300" className="md:hidden space-y-4">
        {reasons.map((reason, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={index}
              className="bg-gradient-to-br from-[#E8F4F6] to-[#BEE2E9] rounded-xl shadow-md"
            >
              <button
                onClick={() => toggleIndex(index)}
                className="w-full flex justify-between items-center px-4 py-3 text-left"
              >
                <span className="font-semibold text-[#3471B8] text-base">
                  {reason.title}
                </span>
                {isOpen ? (
                  <ChevronUp className="text-blue-800 w-5 h-5" />
                ) : (
                  <ChevronDown className="text-blue-800 w-5 h-5" />
                )}
              </button>

              {isOpen && (
                <div className="px-4 pb-4 text-sm text-gray-700 leading-relaxed">
                  {reason.description}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WhyPage;
